import { useMutation, useQueryClient } from "@tanstack/react-query";

import { workbenchBureauApi } from "../../../api/client";
import type { BureauViewResponse } from "./types";
import { viewBureauKeys } from "./viewBureauKeys";

export interface RepullBureauVariables {
  approvalId: string;
  applicantId: string;
  dealerId: string;
}

/**
 * Repulls the credit bureau for ONE applicant via
 * `BureauApi.repullBureau(approvalId, applicantId, dealerId)`. The BFF call is
 * synchronous and returns the refreshed bureau view (same shape as the GET),
 * so on success it is written straight into that applicant's View Bureau
 * cache entry — no polling or refetch needed.
 * @returns {ReturnType<typeof useMutation>} The repull mutation; resolves with the refreshed bureau view.
 */
export function useRepullBureau() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ approvalId, applicantId, dealerId }: RepullBureauVariables): Promise<BureauViewResponse> => {
      const response = await workbenchBureauApi.repullBureau(approvalId, applicantId, dealerId);
      return response.data as BureauViewResponse;
    },
    onSuccess: (data, { approvalId, applicantId }) => {
      queryClient.setQueryData(viewBureauKeys.detail(approvalId, applicantId), data);
    },
  });
}
